// Orders Objs
// used to add orders issued by HCRA to VB profiles, and override licence status
// Profile page:
// - used to add alerts re: notices to overview tab
// - used to populate orders table under notices/orders tab

// Sample Data
// key value - corresponds to the VB's licence number
// title: name of the document, used to populate the link text
// date: date doc was issues
// doc: name of doc, used to populate link path, points to src > docs
// inCompliance: used for compliance orders, will add a note to the profile that the VB has come into compliance
// override: bool, used to override the VB's licence status on all applicable pages, depenedent on the type of order issued
// appeal period: bool, used to override the VB's licence status on all applicable pages, depenedent on the type of order issued

// notice of proposal to make a compliance order
export const complianceOrders = {
  B62900: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "June 15, 2026",
      doc: "1000201315 Ontario Inc. - HCRA Notice of Proposal to Issue Compliance Order- dated June 15- 2026.pdf",
    },
  ],
  B63586: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April  20, 2026",
      doc: "HCRA Notice of Proposal to Make a Compliance Order - Lanescape Construction Inc. - April 20- 2026.pdf",
    }
  ],
  B60165: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 20, 2026",
      doc: "2570970 Ontario Inc. - HCRA Notice of Proposal to Make a Compliance Order- dated March 20- 2026.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "April 8, 2026",
      doc: "2570970 Ontario Inc. - HCRA  Compliance Order- dated April 8- 2026.pdf",
    }
  ],
  B37243: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "February 2, 2026",
      doc: "Centreville Development Corporation -Notice of Proposal to Issue Compliance Order - February 2- 2026.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "February 27, 2026",
      doc: "Centreville Development Corporation -HCRA Compliance Order - February 27- 2026.pdf",
    },
  ],
  B44468: [
    {
      title: "Compliance Order",
      date: "December 12, 2025",
      doc: "Bel-East Corp - Compliance Order - December 12- 2025.pdf",
      fullOrder: true,
    },
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "November 26, 2025",
      doc: "Bel-East Corp - HCRA Notice of Proposal for Compliance Order - November 26- 2025.pdf",
    },
  ],
  B60101: [
    {
      title: "Notice of Proposal to Make a Compliance Order (#1)",
      date: "November 11, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - 2661793 Ontario Inc. (Bluestone Homes) - November 11 2024.pdf",
      fullOrder: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order (#1)",
      date: "November 28, 2024",
      doc: "HCRA Compliance Order - 2661793 Ontario Inc. (Bluestone Homes) - November 28- 2024.pdf",
      status: "In Compliance",
    },
    {
      title: "Notice of Proposal to Make a Compliance Order (#2)",
      date: "April 22, 2025",
      doc: "HCRA-Notice-of-Proposal-Compliance-Order-2661793-Ontario-Inc-Bluestone-Homes-April-22-2025.pdf",
    },
    {
      title: "Compliance Order (#2)",
      date: "May 21, 2025",
      doc: "HCRA Compliance Order - 2661793 Ontario Inc-Bluestone Homes - May 21- 2025.pdf",
    },
  ],
  B62156: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "November 12, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - McCrea Excavating Ltd. - November 12- 2024.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B47446: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "December 23, 2021",
      doc: "Notice of Proposal to Issue a Compliance Order - Luxstone Homes Inc - December 2021.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B43218: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 23, 2022",
      doc: "Notice of Proposal to Issue a Compliance Order - Townsgate Homes Inc - 2022-03-23.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B47290: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 8, 2023",
      doc: "Anix Developments Inc. - Compliance Order - March 8, 2023.pdf",
    },
  ],

  // TODO return to this data structure
  // Adding this now to allow for multiple orders of the same type
  B46762: {
    "04-20-2023": [
      {
        title: "Compliance Order",
        date: "May 5, 2023",
        doc: "HCRA Compliance Order - Pinetree Developments Inc. - May 5, 2023.pdf",
      },
      {
        title: "Notice of Proposal to Make a Compliance Order",
        date: "April 20, 2023",
        doc: "HCRA Notice of Proposal to Make a Compliance Order - Pinetree Developments Inc. - April 20, 2023.pdf",
        fullOrder: true,
      },
    ],
    "03-13-2023": [
      {
        title: "Immediate Compliance Order",
        date: "March 14, 2023",
        doc: "Pinetree Developments Inc. - Immediate Compliance Order - March 14, 2023.pdf",
        immediate: true,
      },
    ],
  },

  B12800: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 10, 2023",
      doc: "Riverview Homes (Niagara) Ltd. - Compliance Order - March 10 2023.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "April 3, 2023",
      doc: "Riverview Homes - Compliance Order - April 3, 2023.pdf",
    },
  ],
  B47130: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 27, 2023",
      doc: "HCRA Notice of Proposal re Compliance Order - Midland Homes & Development - March 27, 2023.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "April 12, 2023",
      doc: "HCRA Compliance Order - Midland Homes and Development - April 12, 2023_2.pdf",
      status: "In Compliance",
    },
  ],
  B36401: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April 5, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - 2169289 Ontario Inc. - April 5, 2024.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "April 22, 2024",
      doc: "2169289 Ontario Inc. - Compliance Order - April 22, 2024.pdf",
    },
  ],
  B60522: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 6, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - Lynphyl Homes Ltd. - March 6, 2024.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "March 21, 2024",
      doc: "Compliance Order - Lynphyl Homes Ltd. - March 21, 2024.pdf",
    },
  ],
  B43317: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April 11, 2024",
      doc: "Dream Maker Developments Inc.  - Notice of Proposal for Compliance Order - April 11, 2024.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B44861: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April 11, 2024",
      doc: "9315055 Canada Corp.  - Notice of Proposal for Compliance Order - April 11, 2024.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B47075: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April 12, 2024",
      doc: "Modern Day Builders Inc. -Notice of Proposal to Issue Compliance Order - April 12, 2024.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "April 29, 2024",
      doc: "Modern Day Builders Inc. - Compliance Order - April 29 2024.pdf",
    },
  ],
  B37007: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "July 19, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - Roca Developments Inc. - July 18, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Compliance Order - Roca Developments Inc. - August 8, 2024.pdf",
      status: "In Compliance",
    },
  ],
  B42866: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - Robert Toon - August 8, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 27, 2024",
      doc: "HCRA Compliance Order - Robert Toon - August 27- 2024.pdf",
      status: "In Compliance",
    },
  ],
  B48115: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - OSMI9 - August 8, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 27, 2024",
      doc: "HCRA Compliance Order - OSMI9 - August 27- 2024.pdf",
      status: "In Compliance",
    },
  ],
  B62296: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - OSMI9 - August 8, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 27, 2024",
      doc: "HCRA Compliance Order - OSMI9 - August 27- 2024.pdf",
      status: "In Compliance",
    },
  ],
  B61168: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - OSMI9 - August 8, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 27, 2024",
      doc: "HCRA Compliance Order - OSMI9 - August 27- 2024.pdf",
      status: "In Compliance",
    },
  ],
  B43054: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "August 8, 2024",
      doc: "HCRA Notice of Proposal re Compliance Order - OSMI9 - August 8, 2024.pdf",
      fullOrder: true,
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Compliance Order",
      date: "August 27, 2024",
      doc: "HCRA Compliance Order - OSMI9 - August 27- 2024.pdf",
      status: "In Compliance",
    },
  ],
  B15209: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "December 09, 2024",
      doc: "HCRA Notice of Proposal to Make Compliance Order - Marjan Homes Inc. - December 9- 2024.pdf",
      fullOrder: true,
    },
    {
      title: "Compliance Order",
      date: "April 04, 2025",
      doc: "HCRA Compliance Order - Marjan Homes Inc. - April 4- 2025.pdf",
    },
  ],
  B46847: [
    {
      title: "Compliance Order",
      date: "February 26, 2025",
      doc: "Oxford Road Developments 4 Inc - HCRA Compliance Order - February 26- 2025.pdf",
      fullOrder: true,
    },
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "February 10, 2025",
      doc: "Oxford Road Developments 4 Inc - HCRA Notice of Proposal for Compliance Order - February 10- 2025.pdf",
    },
  ],
  B43121: [
    {
      title: "Compliance Order",
      date: "March 06, 2025",
      doc: "TIL-KA Construction Inc. - Compliance Order - March 6 2025.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "February 19, 2025",
      doc: "TIL-KA Construction Inc. - Notice of Proposal for Compliance Order - February 19- 2025.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B61111: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "March 24, 2025",
      doc: "HCRA Notice of Proposal to Make Compliance Order - Pine Valley Beaverton Homes Ltd. - March 24- 2025.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B61428: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "April 23, 2025",
      doc: "HCRA Notice of Proposal to Make Compliance Order - Aria Build Corp- April 23- 2025.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
  ],
  B40572: [
    {
      title: "Compliance Order",
      date: "February 6, 2026",
      doc: "Copper Bay Homes Ltd. -Compliance Order - February 6- 2026.pdf",
      inCompliance: true,
      status: "In Compliance",
    },
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "January 19, 2026",
      doc: "Copper Bay Homes Ltd. -Notice of Proposal to Issue Compliance Order - January 19- 2026.pdf",
      status: "In Compliance",
    },
  ],
  B47101: [
    {
      title: "Notice of Proposal to Make a Compliance Order",
      date: "January 15, 2026",
      doc: "Paisley - Whitelaw Inc. - Notice of Proposal for Compliance Order - January 15- 2026.pdf",
      override: true,
    },
  ],
};

export const determineComplianceStatus = (id) => {
  if (complianceOrders[id]?.override || complianceOrders[id][0].override)
    return "Licensed – NOP Under Appeal";
  else return null;
};

export const determineComplianceHdrTxt = (id, orderKey) => {
  if (orderKey && complianceOrders[id][orderKey]) {
    if (complianceOrders[id][orderKey][0].immediate) {
      return "Immediate Compliance Order Issued";
    } else if (complianceOrders[id][orderKey][0].override) {
      return "Notice of Proposal to Make a Compliance Order Issued - Under Appeal";
    } else if (complianceOrders[id][orderKey][0]?.fullOrder) {
      return "Compliance Order Issued";
    } else {
      return "Notice of Proposal to Make a Compliance Order Issued";
    }
  } else if (complianceOrders[id][0]?.immediate)
    return "Immediate Compliance Order Issued";
  else if (complianceOrders[id]?.override || complianceOrders[id][0]?.override)
    return "Notice of Proposal to Make a Compliance Order Issued - Under Appeal";
  else if (complianceOrders[id][0]?.fullOrder) {
    return "Compliance Order Issued";
  } else return "Notice of Proposal to Make a Compliance Order Issued";
};

// notice of conditions on licence
export const conditionsOrders = {
  B40597: [
    {
      title: "Notice of Proposal to Apply Conditions (PDF)",
      date: "September 9, 2021",
      doc: "Notice of Proposal to Refuse Refuse Renewal and Apply Conditions.pdf",
      // override: true,
    },
  ],
  B47295: [
    {
      title: "Notice of Proposal to Apply Conditions (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B44865: [
    {
      title: "Notice of Proposal to Apply Conditions (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B60173: [
    {
      title: "Notice of Proposal to Apply Conditions (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B61269: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B47966: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B61303: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
};

export const determineConditionsStatus = (id) => {
  if (conditionsOrders[id][0].override && conditionsOrders[id][0].appealPeriod)
    return "Licensed - NOP to Apply Conditions";
  else if (conditionsOrders[id][0].override)
    return "Licensed – NOP Under Appeal";
  else return null;
};

export const determineConditionsHdrTxt = (id) => {
  if (conditionsOrders[id][0].override && conditionsOrders[id][0].appealPeriod)
    return "Proposed Conditions on Licence";
  else if (conditionsOrders[id][0].override)
    return "Proposed Conditions on Licence - Under Appeal";
  else return "Conditions on Licence";
};

// notice to refuse
export const refuseOrders = {
  B47697: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B60619: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B60975: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B61214: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B60365: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B46112: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B61057: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      exipred: true,
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B44861: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 20, 2025",
      doc: "Dream Maker - 9315055 - Notice of Proposal to Refuse to Renew - Mail (signed).pdf",
    },
  ],
  B43317: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 20, 2025",
      doc: "Dream Maker - 9315055 - Notice of Proposal to Refuse to Renew - Mail (signed).pdf",
    },
  ],
  B45892: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "June 11, 2020",
      doc: "B45892NoticeofProposal.pdf",
    },
    {
      title: "Amended Notice of Proposal to Refuse to Renew (PDF)",
      date: "August 17, 2020",
      doc: "B45892NoticeofProposal-Amended.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "May 31, 2022",
      doc: "B45892_LAT.pdf",
    },
  ],
  B47109: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "March 15, 2022",
      doc: "Albion Building Consultant Inc. Notice of Proposal.pdf",
      appealed: true,
    },
    {
      title: "LAT Decision",
      date: "January 27, 2023",
      doc: "13954.NHCLA.DEC.pdf",
    },
    {
      title: "Freeze Order",
      date: "February 26, 2024",
      doc: "Albion Building Consultant Inc - Freeze Order - February 26, 2024_1.pdf",
    },
    {
      title: "Freeze Order",
      date: "June 27, 2024",
      doc: "TD Canada Trust HCRA Freeze Order - Albion Building Consultant Inc. - June 27 2024.pdf",
    },
  ],
  B46743: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "January 28, 2022",
      doc: "Notice of Proposal to Refuse to Renew Yarco Developments - January 2022.pdf",
      hideBanner: true,
    },
    {
      title: "LAT Decision",
      date: "September 9, 2022",
      doc: "Yarco LAT Decision.pdf",
    },
    {
      title: "Reconsideration Decision",
      date: "December 14, 2022",
      doc: "18 - 13864.NHCLA Reconsideration Decision.pdf",
    },
    {
      title: "Divisional Court Decision",
      date: "January 8, 2024",
      doc: "Yarco Divisional Court Decision.pdf",
    },
  ],
  B35901: [
    {
      title: "Notice of Proposal to Refuse (PDF)",
      date: "October 1, 2020",
      doc: "B35901-Notice of Proposal to Refuse.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "May 20, 2021",
      doc: "B35901-LAT Decision .pdf",
    },
  ],
  B44902: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "September 9, 2021",
      doc: "Notice of Proposal to Refuse Refuse Renewal and Apply Conditions.pdf",
      // override: true,
    },
  ],
  B45414: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "September 9, 2021",
      doc: "Notice of Proposal to Refuse Refuse Renewal and Apply Conditions.pdf",
      // override: true,
    },
  ],
  B37545: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "July 26, 2023",
      doc: "B37545 Notice of Proposal to Refuse to Renew.pdf",
      // override: true,
    },
  ],
  B62022: [
    {
      title: "Notice of Proposal to Refuse a Licence (PDF)",
      date: "December 11, 2023",
      doc: "B62022 - Notice of Proposal to Refuse an Application.pdf",
      removeLicenceDates: true,
    },
  ],
  B60522: [
    {
      title: "Notice of Proposal to Refuse to Renew a Licence (PDF)",
      date: "November 21, 2024",
      doc: "B61209-Notice of Proposal to Refuse to Renew.pdf",
    },
  ],
  B30875: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 12, 2024",
      doc: "Hira - Notice of Proposal to Refuse to Renew Application Final.pdf",
    },
  ],
  B46593: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 21, 2024",
      doc: "NOP - Sunrise HWY 7.pdf",
      removeLicenceDates: true,
    },
  ],
  B60689: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "November 21, 2024",
      doc: "NOP - Sunrise Stayner.pdf",
      removeLicenceDates: true,
    },
  ],
  B62632: [
    {
      title: "Notice of Proposal to Refuse a Licence (PDF)",
      date: "January 09, 2025",
      doc: "NOP - 9618759 Canada Inc.pdf",
    },
  ],
  B36401: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "January 24, 2025",
      doc: "NOP - 2169289 Ontario Inc.pdf",
    },
  ],
  B60723: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "January 28, 2025",
      doc: "Notice of Proposal to Refuse to Renew (002).pdf",
    },
  ],
  B46672: [
    {
      title: "LAT Decision (PDF)",
      date: "September 25, 2025",
      doc: "16819.NHCLA.DEC.pdf",
    },
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "February 21, 2025",
      doc: "Notice of Proposal to Refuse an Application.pdf",
    },
  ],
  B12265: [
    {
      title: "Notice of Proposal to Refuse to Renew (PDF)",
      date: "August 8, 2025",
      doc: "R.O. Beam - Notice of Proposal to Refuse to Renew.pdf",
    },
  ],
  B42051: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "October 30, 2024",
      doc: "Notice of Proposal to Refuse an Application and Revoke Licences.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "August 18, 2025",
      doc: "16458.NHCLA - Decision.pdf",
    },
  ],
  B60305: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "October 30, 2024",
      doc: "Notice of Proposal to Refuse an Application and Revoke Licences.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "August 18, 2025",
      doc: "16458.NHCLA - Decision.pdf",
    },
  ],
};

export const determineRefuseStatus = (id) => {
  if (
    refuseOrders[id][0].override &&
    refuseOrders[id][0].appealPeriod &&
    refuseOrders[id][0].neverlicenced
  )
    return "NOP to Refuse a Licence";
  else if (refuseOrders[id][0].expired) return "NOP to Refuse to Renew";
  else if (refuseOrders[id][0].override && refuseOrders[id][0].appealPeriod)
    return "Licensed - NOP to Refuse a Licence";
  else if (refuseOrders[id][0].override) return "Licensed – NOP Under Appeal";
  else return "Refused";
};

export const determineRefusedHdrTxt = (id) => {
  if (refuseOrders[id][0].override && refuseOrders[id][0].appealPeriod)
    return "Proposed Licence Refusal";
  else if (refuseOrders[id][0].override)
    return "Proposed Licence Refusal – Under Appeal";
  else return "Licence Refused";
};

// notice to revoke
export const revokeOrders = {
  B60959: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "November 28, 2025",
      doc: "LJM - Notice of Proposal.pdf",
      override: true,
    },
    {
      title: "Supplement to the Notice of Proposal to Revoke a Licence (PDF)",
      date: "February 19, 2026",
      doc: "LJM - Supplement to Notice of Proposal to Refuse to Renew.pdf",
    },
    {
      title:
        "Further Supplement to the Notice of Proposal to Revoke a Licence (PDF)",
      date: "February 26, 2026",
      doc: "LJM - Further Supplement to Notice of Proposal (signed).pdf",
    },
  ],
  B48217: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "October 30, 2024",
      doc: "Notice of Proposal to Refuse an Application and Revoke Licences.pdf",
      onlyDocument: true,
    },
  ],
  B35744: [
    {
      title: "Notice of Proposal to Revoke (PDF)",
      date: "September 26, 2022",
      doc: "Marcel Dewit Notice of Proposal to Revoke a Licence_1.pdf",
    },
  ],
  B41493: [
    {
      title: "Notice of Proposal to Revoke (PDF)",
      date: "September 23, 2020",
      doc: "41493 - 7853742 Canada Inc - NOP.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "February 18, 2021",
      doc: "08 - 13122.NHCLA.MOT.DEC.ORD.pdf",
    },
  ],
  B45614: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B44938: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B46333: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "August 25, 2022",
      doc: "AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.pdf",
    },
    {
      title: "Fresh as Amended Notice of Proposal to Apply Conditions (PDF)",
      date: "September 27, 2022",
      doc: "DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.pdf",
    },
    {
      title: "LAT Order (PDF)",
      date: "November 28, 2022",
      doc: "AdiLAT.pdf",
    },
  ],
  B46762: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "May 9, 2023",
      doc: "Pinetree - Notice of Proposal to Revoke a Licence.pdf",
    },
  ],
  B43256: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "May 30, 2024",
      doc: "Notice of Proposal to Revoke a Licence - SHDI.pdf",
      override: true,
      appealPeriod: true,
    },
  ],
  B43313: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "July 31, 2024",
      doc: "2024.07.31 - Notice of Proposal to Revoke- Mariman Homes.pdf",
    },
  ],
  B48441: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "December 11, 2024",
      doc: "Notice of Proposal to Revoke a License- 1 Blue Goose Developments Inc..pdf",
    },
  ],
  B47788: [
    {
      title: "Notice of Proposal to Revoke a Licence (PDF)",
      date: "June 11, 2025",
      doc: "Notice of Proposal to Revoke a Licence 2250310 Ontario Inc - signed.pdf",
    },
  ],
};

export const determineRevokeStatus = (id) => {
  if (revokeOrders[id][0].override && revokeOrders[id][0].appealPeriod)
    return "Licensed - NOP to Revoke a Licence";
  else if (revokeOrders[id][0].override) return "Licensed – NOP Under Appeal";
  else if (revokeOrders[id][0].onlyDocument) return false;
  else return "Revoked";
};

export const determineRevokedHdrTxt = (id) => {
  if (revokeOrders[id][0].override && revokeOrders[id][0].appealPeriod)
    return "Proposed Licence Revocation";
  else if (revokeOrders[id][0].override)
    return "Proposed Licence Revocation – Under Appeal";
  else return "Licence Revoked";
};

// advertising orders
export const advertisingOrders = {};

export const determineAdvertisingStatus = (id, builderStatus) => {
  if (advertisingOrders[id][0].override) return "Licensed – Order Under Appeal";
  else return builderStatus;
};

export const determineAdvertisingHdrTxt = (id) => {
  if (advertisingOrders[id][0].override || advertisingOrders[id][0].underAppeal)
    return "Advertising Order – Under Appeal";
  else return "Advertising Order Issued";
};

// suspension orders
export const suspensionOrders = {
  B44380: [
    {
      title: "Notice of Proposal to Revoke (PDF)",
      date: "February 16, 2023",
      doc: "Violette NOP to Revoke_Redacted.pdf",
      revoked: true,
    },
    {
      title: "Immediate Suspension Order (PDF)",
      date: "February 16, 2023",
      doc: "Violette Immediate Suspension Order_Redacted.pdf",
    },
    {
      title: "Asset Freeze Order (1) (PDF)",
      date: "February 16, 2023",
      doc: "Patrick Violette HCRA Freeze Order - February 16, 2023_Redacted.pdf",
    },
    {
      title: "Asset Freeze Order (2) (PDF)",
      date: "February 16, 2023",
      doc: "32836 TD Bank HCRA Freeze Order - Patrick Violette - February 16, 2023.pdf",
    },
    {
      title: "Asset Freeze Order (3) (PDF)",
      date: "February 16, 2023",
      doc: "33156 TD Bank HCRA Freeze Order - Patrick Violette - February 16, 2023.pdf",
    },
    {
      title: "Immediate Compliance Order (PDF)",
      date: "February 16, 2023",
      doc: "Patrick Violette HCRA Immediate Compliance Order - February 16, 2023_Redacted.pdf",
    },
  ],
  B48960: [
    {
      title: "Notice of Proposal to Revoke (PDF)",
      date: "February 16, 2023",
      doc: "Viloham NOP to Revoke_Redacted.pdf",
      revoked: true,
    },
    {
      title: "Immediate Suspension Order (PDF)",
      date: "February 16, 2023",
      doc: "Viloham Immediate Suspension Order_Redacted.pdf",
    },
    {
      title: "Asset Freeze Order (1) (PDF)",
      date: "February 16, 2023",
      doc: "Viloham Trades Inc. (Highbridge Construction) HCRA Freeze Orders - February 16, 2023_Redacted.pdf",
    },
    {
      title: "Asset Freeze Order (2) (PDF)",
      date: "February 16, 2023",
      doc: "01006 - CIBC HCRA Freeze Order - Viloham Trades Inc. (Highbridge Construction) - February 16, 2023.pdf",
    },
    {
      title: "Immediate Compliance Order (PDF)",
      date: "February 16, 2023",
      doc: "Viloham Trades Inc. (Highbridge Construction) HCRA Immediate Compliance Order - February 16, 2023_Redacted.pdf",
    },
  ],
  B60578: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B48820: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B47480: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B60186: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B61469: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B61632: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B61656: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B61468: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B61334: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B41428: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B60363: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B48110: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B47823: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B47192: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "June 19, 2023",
      doc: "Stateview - NOP to Suspend.pdf",
      expired: true,
    },
  ],
  B43313: [
    {
      title: "Immediate Suspension Order  (PDF)",
      date: "December 5, 2023",
      doc: "B43313 - Notice of Proposal to Suspend a Licence.pdf",
      hideBanner: true,
    },
  ],
  B43121: [
    {
      title: "Immediate Suspension Order (PDF)",
      date: "April 04, 2025",
      doc: "Immediate Suspension Order and Proposal to Suspend - signed.pdf",
      hideBanner: true,
    },
  ],
  B61611: [
    {
      title:
        "Notice of Proposal to Suspend a Licence and Immediate Suspension Order (PDF)",
      date: "June 16, 2025",
      doc: "61611-Immediate Suspension Order and Notice of Proposal to Suspend.pdf",
      override: true,
      appealPeriod: true,
      immediateSuspension: true,
    },
  ],
  B47730: [
    {
      title: "Notice of Proposal to Suspend a Licence (PDF)",
      date: "January 29, 2026",
      doc: "NOP to Suspend - Spring Garden.pdf",
      expired: true,
    },
  ],
};

export const determineSuspendedHdrTxt = (id) => {
  if (
    suspensionOrders[id][0].override &&
    suspensionOrders[id][0].appealPeriod &&
    suspensionOrders[id][0].immediateSuspension
  )
    return "Notice of Proposal to Suspend a Licence and Immediate Suspension Order";
  else if (
    suspensionOrders[id][0].override &&
    suspensionOrders[id][0].appealPeriod
  )
    return "Proposed Licence Suspension";
  else if (suspensionOrders[id][0].appealPeriod)
    return "Notice of Proposal to Suspend a Licence and Immediate Suspension Order - Under Appeal";
  else if (suspensionOrders[id][0].expired)
    return "Licence Expired during Suspension";
  else if (suspensionOrders[id][0].revoked) return "Licence Revoked";
  else return "Licence Suspended";
};

export const determineSuspensionStatus = (id, builderStatus) => {
  if (
    suspensionOrders[id][0].override &&
    suspensionOrders[id][0].appealPeriod &&
    suspensionOrders[id][0].immediateSuspension
  )
    return "Suspended";
  else if (
    suspensionOrders[id][0].override &&
    suspensionOrders[id][0].appealPeriod &&
    suspensionOrders[id][0].licensed
  )
    return "Licensed - Proposed Licence Suspension";
  else if (
    suspensionOrders[id][0].override &&
    suspensionOrders[id][0].appealPeriod
  )
    return "Proposed Licence Suspension";
  else if (suspensionOrders[id][0].override) return "Suspended";
  else if (
    suspensionOrders[id][0].appealPeriod &&
    suspensionOrders[id][0].updateLicense
  )
    return "Licensed- NOP Under Appeal";
  else return builderStatus;
};

// restraining orders
export const restrainingOrders = {
  B47109: [
    {
      title: "Notice of Application for a Restraining Order",
      date: "August 9, 2024",
      doc: "Albion - Notice of Application - Restraining Order.pdf",
    },
    {
      title: "Interim Restraining Order",
      date: "September 24, 2024",
      doc: "Interim Restraining Order- Albion- dated Sept 24 2024.pdf",
    },
    {
      title: "Restraining Order",
      date: "July 1, 2026",
      doc: "New Home Construction v. Albion Building CV-24-725406-0000 Order.pdf",
    },
  ],
};

// suspension orders
export const adminPenalties = {
  B30889: [
    {
      title: "Amended Adminstrative Penalty (PDF)",
      date: "June 19, 2026",
      doc: "Amended Administrative Penalty Order - 911578 Ontario Limited oa Birchwood Homes.pdf",
    }
  ],
  B63218: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "May 5, 2026",
      doc: "Administrative Penalty Order - WRP Reid Enterprises Inc..pdf",
    }
  ],
  B46793: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "February 13, 2026",
      doc: "Administrative Penalty Order - 859 West Condos Inc..pdf",
      appealed: true,
    },
  ],
  B42139: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "February 17, 2026",
      doc: "ISP-0126 - Administrative Penalty Order - Tuscan Valley.pdf",
    },
  ],
  B63018: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "March 13, 2024",
      doc: "Administrative Penalty Order - Ali (1).pdf",
    },
    {
      title: "Decision and Order (PDF)",
      date: "November 21, 2024",
      doc: "Waqas Ali and Zanib Butt- Decision and Order dated November21- 2024.pdf",
    },
  ],
  B63019: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "March 13, 2024",
      doc: "Administrative Penalty Order - Butt.pdf",
    },
    {
      title: "Decision and Order (PDF)",
      date: "November 21, 2024",
      doc: "Waqas Ali and Zanib Butt- Decision and Order dated November21- 2024.pdf",
    },
  ],
  B48213: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "June 4, 2024",
      doc: "ISP-0059 - Administrative Penalty Order - GC King Bond - Amended.pdf",
    },
    {
      title: "Consent Order (PDF)",
      date: "November 20, 2024",
      doc: "GC King Bond GP Inc. - Consent Order dated November 20- 2024.pdf",
    },
  ],
  B44865: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "March 1, 2023",
      doc: "B44865 Administrative Penalty Order.pdf",
    },
  ],
  B63436: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 11, 2024",
      doc: "INV-0287 - Administrative Penalty Order - Harjot Khehra.pdf",
    },
    {
      title: "LAT Decision (PDF)",
      date: "September 9, 2024",
      doc: "Harjot Khehra- Amended Motion Decision dated September 9- 2024.pdf",
    },
  ],
  B62335: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 11, 2024",
      doc: "INV-0224 - Administrative Penalty Order - Samalie Nsubuga.pdf",
    },
    {
      title: "LAT Decision & Order (PDF)",
      date: "July 21, 2025",
      doc: "16114.NHCLA and 16115.NHCLA.DEC.ORD.pdf",
    },
  ],
  B62334: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 11, 2024",
      doc: "INV-0224- Administrative Penalty Order - Joy Nneji.pdf",
    },
    {
      title: "LAT Decision & Order (PDF)",
      date: "July 21, 2025",
      doc: "16114.NHCLA and 16115.NHCLA.DEC.ORD.pdf",
    },
  ],
  B63437: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 11, 2024",
      doc: "INV-0287 - Administrative Penalty Order - Jasjit Sandhu.pdf",
    },
  ],
  B43313: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 31, 2024",
      doc: "2024.07.31 - Administrative Penalty Order- Mariman Homes.pdf",
    },
  ],
  B63207: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "September 17, 2024",
      doc: "APO - Trumper.pdf",
    },
    {
      title: "Consent Order (PDF)",
      date: "March 17, 2025",
      doc: "16301.NHCLA.CON.ORD.pdf",
    },
  ],
  B61009: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "November 19, 2024",
      doc: "Administrative Penalty Order - Jacob Hiebert.pdf",
    },
  ],
  B62727: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "November 19, 2024",
      doc: "Administrative Penalty Order - Abraam Construction Inc_.pdf",
    },
    {
      title: "Decision & Order (PDF)",
      date: "April 24, 2025",
      doc: "12-16535-NHCLA-DEC-T.pdf",
    },
  ],
  B62714: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "December 20, 2024",
      doc: "INV-0303 - Administrative Penalty Order - Destination Estates Ltd.pdf",
    },
  ],
  B62980: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "June 02, 2025",
      doc: "Administrative Penalty Order - Ehsan Forouzandeh.pdf",
    },
  ],
  B62373: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "June 20, 2025",
      doc: "Administrative Penalty Order - Daniel Hiebert.pdf",
    },
  ],
  500003508: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 2, 2025",
      doc: "Administrative Penalty Order - Century 21 Best Sellers Ltd. - Copy.pdf",
    },
    {
      title: "LAT - Decision & Order (PDF)",
      date: "February 17, 2026",
      doc: "17336.NHCLA.DEC.pdf",
    },
  ],
  500002432: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 2, 2025",
      doc: "Administrative Penalty Order - Barone Consulting Inc..pdf",
    },
  ],
  B61993: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 3, 2025",
      doc: "Administrative Penalty Order - Paul Starkman.pdf",
      appealed: true,
    },
  ],
  B63222: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 3, 2025",
      doc: "Administrative Penalty Order - Esuna Inc..pdf",
      appealed: true,
    },
  ],
  B48440: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "July 18, 2025",
      doc: "Administrative Penalty Order - 10184110 Canada Inc_.pdf",
    },
    {
      title: "LAT Decision & Order (PDF)",
      date: "January 23, 2026",
      doc: "17429.NHCLA.DEC.pdf",
    }
  ],
  B62769: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "August 12, 2025",
      doc: "Administrative Penalty Order - Roger Sherwood.pdf",
    },
  ],
  B61513: [
    {
      title: "Notice of Withdrawal (PDF)",
      date: "March 27, 2026",
      doc: "Notice of Withdrawal.pdf",
      hideBanner: true,
    },
  ],
  B62674: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "October 27, 2025",
      doc: "Administrative Penalty Order - 2736003 Ontario Inc..pdf",
    },
  ],
  B62981: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "October 15, 2025",
      doc: "Administrative Penalty Order - 11022873 Canada Inc..pdf",
    },
    {
      title: "LAT Decision & Order (PDF)",
      date: "April 13, 2026",
      doc: "16.a.17917.NHCLA - DECISION.pdf",
    }
  ],
  B40272: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "April 10, 2026",
      doc: "Fresh as Amended Administrative Penalty Order.pdf",
    },
  ],
  B64675: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "January 5, 2026",
      doc: "Administrative Penalty Order - Lidia Haluszka.pdf",
    },
  ],
  B64674: [
    {
      title: "Adminstrative Penalty (PDF)",
      date: "January 5, 2026",
      doc: "Administrative Penalty Order - Jerzy Haluszka.pdf",
    },
  ],
};

export const determineAdminPenaltiesHdrTxt = (id) => {
  if (adminPenalties[id][0].appealed)
    return "Administrative Penalty - Under Appeal";
  else return "Administrative Penalty";
};

// determineStatusOverride
// props: builder ID number, builder licence status
export const determineStatusOverride = (builderID, builderStatus) => {
  if(builderID === "B46793" || builderID === "B42139") {
    return "Licensed";
  }
  if (builderStatus === "Charged and/or Convicted") {
    return builderStatus;
  } else if (refuseOrders[builderID] && refuseOrders[builderID][0].override) {
    return determineRefuseStatus(builderID);
  } else if (revokeOrders?.[builderID]?.[0].override) {
    return determineRevokeStatus(builderID);
  } else if (
    complianceOrders?.[builderID]?.override ||
    complianceOrders?.[builderID]?.[0]?.override
  ) {
    return determineComplianceStatus(builderID);
  } else if (
    conditionsOrders[builderID] &&
    conditionsOrders[builderID][0].override
  ) {
    return determineConditionsStatus(builderID);
  } else if (
    advertisingOrders[builderID] &&
    advertisingOrders[builderID][0].override
  ) {
    return "Licensed – NOP Under Appeal";
  } else if (suspensionOrders[builderID]) {
    return determineSuspensionStatus(builderID, builderStatus);
  } else if (advertisingOrders[builderID]) {
    return determineAdvertisingStatus(builderID, builderStatus);
  } else return builderStatus;
};

export const freezeOrders = {
  B60522: [
    {
      title: "Freeze Order",
      date: "June 19, 2024",
      doc: "Scotiabank HCRA Freeze Orders - Lynphyl Homes et al. - June 18 2024.pdf",
    },
    {
      title: "Freeze Order",
      date: "June 20, 2024",
      doc: "HCRA Freeze Orders - Lynphyl Homes Ltd. - June 18, 2024.pdf",
    },
  ],
};

// disciplineAllegations
export const disciplineAllegations = {
  B46885: [
    {
      referralDate: "October 31, 2024",
      licensee: "Starlish Home Corp.",
      doc: "Starlish summary of Allegations.pdf",
      nextSteps: "Case Conference: to be scheduled ",
    },
  ],
  B46303: [
    {
      referralDate: "November 10, 2023",
      licensee: "Mapleview Developments Ltd.",
      doc: "Mapleview Developments Ltd - Statement of Allegations Summary - 042024.pdf",
      nextSteps:
        "Proceedings stayed due to Receivership Order dated March 21, 2024",
    },
  ],
};

// disciplineDecisions
export const disciplineDecisions = {
  B47898: [
    {
      decisionDate: "June 19, 2026",
      licensee: "Dormer Bond Inc.",
      decisionTxt: "Dormer Bond Inc. violated section 3 of the Code of Ethics by charging purchasers unjustified alternate materials fees and unsupported legal and administrative fees. It committed 90 violations of this section. Dormer Bond Inc. did not obstruct a purchaser from making a complaint to the Registrar.",
      outcomesTxt: "Sentencing to be determined at a later date.",
      doc: "Decision and Reasons re HCRA and Dormer Bond Inc_Signed.pdf",
    },
  ],
  B45312: [
    {
      decisionDate: "September 17, 2025",
      licensee: "2401886 Ontario Limited",
      decisionTxt:
        "The Discipline Committee granted 2401886 Ontario Limited’s non-suit motion and dismissed 13 counts in the statement of allegations",
      outcomesTxt: "No findings were made against this licensee",
      documents: [
        {
          title:
            "Oral Ruling of the Panel-Non-Suit Motion Delivered on September 17, 2025",
          doc: "2025-09-17 HCRA v Briarwood - Oral Ruling re granting non-suit motion.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Non-Suit Motion: Preliminary Issues Delivered on September 15, 2025",
          doc: "2025-09-15 HCRA v Briarwood - Oral Ruling re allowing non-suit motion to proceed.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Motion re Expert Qualifications Delivered September 12, 2025 ",
          doc: "2025-09-12 HCRA v Briarwood - Oral ruling re motion to disqualify expert witness.pdf",
        },
      ],
    },
  ],
  B47464: [
    {
      decisionDate: "September 17, 2025",
      licensee: "863195 Ontario Limited",
      decisionTxt:
        "The Discipline Committee granted 863195 Ontario Limited’s non-suit motion and dismissed 13 counts in the statement of allegations",
      outcomesTxt: "No findings were made against this licensee",
      documents: [
        {
          title:
            "Oral Ruling of the Panel-Non-Suit Motion Delivered on September 17, 2025",
          doc: "2025-09-17 HCRA v Briarwood - Oral Ruling re granting non-suit motion.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Non-Suit Motion: Preliminary Issues Delivered on September 15, 2025",
          doc: "2025-09-15 HCRA v Briarwood - Oral Ruling re allowing non-suit motion to proceed.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Motion re Expert Qualifications Delivered September 12, 2025 ",
          doc: "2025-09-12 HCRA v Briarwood - Oral ruling re motion to disqualify expert witness.pdf",
        },
      ],
    },
  ],
  B43292: [
    {
      decisionDate: "September 17, 2025",
      licensee: "Briarwood Estates (Sutton) Ltd.",
      decisionTxt:
        "The Discipline Committee granted Briarwood Estates (Sutton) Ltd.’s non-suit motion and dismissed 13 counts in the statement of allegations",
      outcomesTxt: "No findings were made against this licensee",
      documents: [
        {
          title:
            "Oral Ruling of the Panel-Non-Suit Motion Delivered on September 17, 2025",
          doc: "2025-09-17 HCRA v Briarwood - Oral Ruling re granting non-suit motion.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Non-Suit Motion: Preliminary Issues Delivered on September 15, 2025",
          doc: "2025-09-15 HCRA v Briarwood - Oral Ruling re allowing non-suit motion to proceed.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Motion re Expert Qualifications Delivered September 12, 2025 ",
          doc: "2025-09-12 HCRA v Briarwood - Oral ruling re motion to disqualify expert witness.pdf",
        },
      ],
    },
  ],
  B48253: [
    {
      decisionDate: "September 17, 2025",
      licensee: "Briarwood (Angus) Ltd.",
      decisionTxt:
        "The Discipline Committee granted Briarwood Estates (Angus) Ltd.’s non-suit motion and dismissed 13 counts in the statement of allegations",
      outcomesTxt: "No findings were made against this licensee",
      documents: [
        {
          title:
            "Oral Ruling of the Panel-Non-Suit Motion Delivered on September 17, 2025",
          doc: "2025-09-17 HCRA v Briarwood - Oral Ruling re granting non-suit motion.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Non-Suit Motion: Preliminary Issues Delivered on September 15, 2025",
          doc: "2025-09-15 HCRA v Briarwood - Oral Ruling re allowing non-suit motion to proceed.pdf",
        },
        {
          title:
            "Oral Ruling of the Panel- Motion re Expert Qualifications Delivered September 12, 2025 ",
          doc: "2025-09-12 HCRA v Briarwood - Oral ruling re motion to disqualify expert witness.pdf",
        },
      ],
    },
  ],
  B28375: [
    {
      decisionDate: "November 20, 2022",
      licensee: "1332741 Ontario Inc./Patten Homes 2000",
      decisionTxt:
        "NHCLA - Code of Ethics - s. 2 Licencee to ensure compliance; s.9 Intimidation coercion etc.; and s. 16 Obstruction of complaints",
      outcomesTxt:
        "1332741 Ontario Inc. o/a Patten Homes 2000 is ordered to pay a fine of $10,000 and to arrange for its employees to complete the following education courses: Customer Service and Tarion Requirements, Legal Issues in Housing",
      doc: "Decision and Order - Patten Homes.pdf",
    },
  ],
  B46112: [
    {
      decisionDate: "October 17, 2024",
      licensee: "LJM Developments (Stoney Creek) Inc.",
      decisionTxt:
        "LJM Developments (Stoney Creek) Inc. has failed to comply with Section 3 and 6 of the Code of Ethics, being Ontario regulation 245/21 made under the New Home Construction Licensing Act, 2017.",
      outcomesTxt:
        "LJM Developments (Stoney Creek) Inc. is ordered to pay a fine of $60,000 to the HCRA and arrange for Liaquat Mian and Muhammad Ahsan to complete and pass educational courses within 60 days of the date of the Order.",
      doc: "HCRA v. LJM Decision - October 25 2024.pdf",
    },
  ],
};

export const regActionCalc = (id, status) => {
  const regActionArr = [];
  if (status === "Charged and/or Convicted")
    regActionArr.push("Charged and/or Convicted");
  if (disciplineDecisions[id] || disciplineAllegations[id])
    regActionArr.push("Disciplinary Activity");
  if (advertisingOrders[id]) regActionArr.push(determineAdvertisingHdrTxt(id));
  if (revokeOrders[id] && !revokeOrders[id][0].appealed)
    regActionArr.push(determineRevokedHdrTxt(id));
  if (refuseOrders[id] && !refuseOrders[id][0].appealed)
    regActionArr.push(determineRefusedHdrTxt(id));
  if (suspensionOrders[id] && !suspensionOrders[id][0].appealed) {
    regActionArr.push(determineSuspendedHdrTxt(id));
  }

  // TODO: remove excpetion for B48282, add this as new status
  if (id === "B48282")
    regActionArr.push("Proposed Licence Refusal - Under Appeal");

  if (
    conditionsOrders[id] &&
    !conditionsOrders[id][0].appealed &&
    !conditionsOrders[id][0].hidden
  )
    regActionArr.push(determineConditionsHdrTxt(id));
  if (complianceOrders[id])
    regActionArr.push("Notice of Proposal to Make a Compliance Order");

  return regActionArr.sort();
};
/*
// This is dynamic now. Data is comeing from snowflake
export const insolvencyProceedings = {
  B47614: [
    {
      doc: "Receivership Order Dated October 19, 2023.pdf",
      title: "Receivership Order",
      date: "October 18, 2023",
    },
  ],
  B46732: [
    {
      doc: "001-IN_1.PDF",
      title: "CCAA Order",
      date: "April 20, 2022",
    },
  ],
  B43313: [
    {
      doc: "Mariman Homes Receivership Case.pdf",
      title: "Receivership Order",
      date: "January 16, 2024",
    },
  ],
  B46186: [
    {
      doc: "B46186-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "June 13, 2024",
    },
  ],
  B47821: [
    {
      doc: "MCAP-V_2.PDF",
      title: "Receivership Order",
      date: "December 11, 2023",
    },
  ],
  B61531: [
    {
      doc: "B61531-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "October 18, 2023",
    },
  ],
  B61431: [
    {
      doc: "B61431-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "June 13, 2023",
    },
  ],
  B60843: [
    {
      doc: "B61349-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "November 14, 2023",
    },
  ],
  B48869: [
    {
      doc: "B48869-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "June 13, 2023",
    },
  ],
  B46727: [
    {
      doc: "interim-receivership-order-dated-december-19-2023.pdf",
      title: "Receivership Order",
      date: "December 19, 2023",
    },
    {
      doc: "receivership-order-dated-february-5-2024.pdf",
      title: "Receivership Order",
      date: "February 05, 2024",
    },
  ],
  B48736: [
    {
      doc: "Jefferson Properties - Court Order appointing receiver.pdf",
      title: "Receivership Order",
      date: "December 21, 2023",
    },
  ],
  B46593: [
    {
      doc: "(2023.10.13) Receivership-order-dated-june-9-2021.pdf",
      title: "Receivership Order",
      date: "June 09, 2021",
    },
  ],
  B62185: [
    {
      doc: "Sunrise Elmvale - Order appointing receiver.pdf",
      title: "Receivership Order",
      date: "April 15, 2024",
    },
  ],
  B36070: [
    {
      doc: "Order-Appoint-a-Receiver-J-Kimmel-held-Jul-24-2024-ISSUED-ENTERED.pdf",
      title: "Receivership Order",
      date: "July 24, 2023",
    },
  ],
  B46303: [
    {
      doc: "receivership-order-dated-march-21-2024.pdf",
      title: "Receivership Order",
      date: "May 21, 2024",
    },
  ],
  B12265: [
    {
      doc: "Court-Order-for-Appointment-of-Receiver-for-specified-properties-of-1703306-Ontario-Inc.-and-R.O.-Beam-Son-Construction-Limited.pdf",
      title: "Receivership Order",
      date: "April 26, 2024",
    },
  ],
  B46579: [
    {
      doc: "6)RECE_1.PDF",
      title: "Receivership Order",
      date: "May 27, 2024",
    },
  ],
  B43256: [
    {
      doc: "Receivership-Order-Applicant-Marshallzehr179820.1.pdf",
      title: "Receivership Order",
      date: "May 31, 2024",
    },
  ],
  B46726: [
    {
      doc: "interim-receivership-order-dated-december-19-2023.pdf",
      title: "Receivership Order",
      date: "December 19, 2023",
    },
    {
      doc: "receivership-order-dated-february-5-2024.pdf",
      title: "Receivership Order",
      date: "February 05, 2024",
    },
  ],
  B44647: [
    {
      doc: "Order Appointing Receiver - 128 Hazelton.pdf",
      title: "Receivership Order",
      date: "June 04, 2024",
    },
  ],
  // B31329: [
  //   {
  //     doc: "4857-2506-3103 v1 Order  - 16-MAY-2024 (002).pdf",
  //     title: "Receivership Order",
  //     date: "May 16, 2024",
  //   },
  // ],
  B60689: [
    {
      doc: "ORDER-of-Justice-Black-APPLICANTS-FEB-29-2024-00664292xC0375.pdf",
      title: "Receivership Order",
      date: "February 29, 2024",
    },
  ],
  B44954: [
    {
      doc: "King David Inc Receivership-Order-Applicant-First-Source-20DEC23.pdf",
      title: "Receivership Order",
      date: "December 21, 2023",
    },
  ],
  B45585: [
    {
      doc: "2023.10.20 Order of Justice Osborne - Applicant - KEB Hana Bank - 18-OCT-2023.pdf",
      title: "Receivership Order",
      date: "October 18, 2023",
    },
    {
      doc: "2024.10.22 Amended and Restated Initial Order.pdf",
      title: "CCAA Order",
      date: "October 15, 2024",
    },
  ],
  B48115: [
    {
      doc: "BaraKKa and Loretto.pdf",
      title: "Receivership Order",
      date: "October 21, 2024",
    },
  ],
  B61168: [
    {
      doc: "BaraKKa and Loretto.pdf",
      title: "Receivership Order",
      date: "October 21, 2024",
    },
  ],
  B62296: [
    {
      doc: "BaraKKa and Loretto.pdf",
      title: "Receivership Order",
      date: "October 17, 2024",
    },
  ],
  B39308: [
    {
      doc: "Order Appointing Receiver - Ashcroft Homes - Eastboro Inc.pdf",
      title: "Receivership Order",
      date: "October 17, 2024",
    },
  ],
  B47614: [
    {
      doc: "Receivership Order dated October 12, 2023.pdf",
      title: "Receivership Order",
      date: "October 12, 2023",
    },
  ],
  B60344: [
    {
      doc: "2460467 receivership-appointment-order-dated-aug-7-2024.pdf",
      title: "Receivership Order",
      date: "August 7, 2024",
    },
  ],
  B61915: [
    {
      doc: "B61915-RECEIV_1.PDF",
      title: "Receivership Order",
      date: "January 18, 2024",
    },
    {
      doc: "B61915-RECEIV_2.PDF",
      title: "Receivership Order",
      date: "January 18, 2024",
    },
  ],
  B61161: [
    {
      doc: "receivership-order-may8-2023.pdf",
      title: "Receivership Order",
      date: "May 8, 2023",
    },
  ],
  B48340: [
    {
      doc: "Receivership Order Dated October 19, 2023.pdf",
      title: "Receivership Order",
      date: "October 18, 2023",
    },
  ],
  B61682: [
    {
      doc: "June 11, 2024 Receivership Order.pdf",
      title: "Receivership Order",
      date: "June 11, 2024",
    },
  ],
  B62670: [
    {
      doc: "Jefferson Properties - Court Order appointing receiver.pdf",
      title: "Receivership Order",
      date: "December 21, 2023",
    },
  ],
  B48213: [
    {
      doc: "en-ca-insolv-kingbond-ReceivershipAppointmentOrder-May22025.pdf",
      title: "Receivership Order",
      date: "May 02, 2025",
    },
  ],
  B46847: [
    {
      doc: "Receivership-Order-dated-June-6-2025-(3) - 2250310 Ontario Inc.pdf",
      title: "Receivership Order",
      date: "June 6, 2025",
    },
  ],
  B47788: [
    {
      doc: "Issued-Order-of-Justice-Kimmel-06-JUN-2025 - Oxford Road Dev.pdf",
      title: "Receivership Order",
      date: "June 6, 2025",
    },
  ],
  B45584: [
    {
      doc: "2024.10.15 Initial Order - Mizrahi 1451.pdf",
      title: "CCAA Order",
      date: "October 15, 2024",
    },
  ],
  B45485: [
    {
      doc: "Order-of-Justice-Conway-Cameron-Stephens-Mortgage-Order-10-OCT-202515351813.1.pdf",
      title: "Receivership Order",
      date: "October 10, 2025",
    },
  ],
};
*/
